import './menstrualeducationwhy.css'

const MenstrualEducationWhy = () => {
  return (
    <section className='menstrualWhy section__padding'>

      {/* TÍTULO */}
      
      <h2 className='menstrualWhy__title'>
        ¿Por qué un libro de educación menstrual?
      </h2>

      {/* LISTA */}
      <ul className='menstrualWhy__list'>
        <li>
          Porque la menstruación —también el ciclo y la menopausia—,
          siguen estando marcadas por el estigma, el silencio y la desinformación
        </li>
        <li>
          Porque la educación menstrual es un campo propio, con fundamentos,
          ética y metodología
        </li>
        <li>
          Porque por primera vez, se ha conceptualizado el rol, la ética
          y las prácticas de la educadora menstrual
        </li>
        <li>
          Porque no existía hasta hoy un glosario de educación menstrual,
          sentipensado con perspectiva feminista, científica,
          interseccional, internacional y de Derechos Humanos
        </li>
        <li>
          Porque más que nunca hay que hacer del presente una posibilidad
          para la vida (todas las vidas) con dignidad, justicia, salud y
          calidad de vida, y en defensa de los ecosistemas
        </li>
        <li>
          Porque ofrece una bibliografía excepcional
        </li>
      </ul>

    </section>
  )
}

export default MenstrualEducationWhy
